import { TableColumn } from "./dataInterface";

export const followCallTableColumn: TableColumn = {
  title: "フォローコール一覧",
  detail: false,
  detailTitle: "エントリー詳細",
  detailColumn: "詳細",
  detailKey: ["id", "follow_call_hope_time", "follow_call_memo"],
  addTitle: "フォローコール登録",
  editAuth: [],
  tableFunction: [
    {
      name: "フォローコール",
      width: "120px",
      auth: ["パートナー", "営業アカウント"],
    },
    {
      name: "停止・再開",
      width: "80px",
      auth: ["マスターアカウント", "スタッフアカウント"],
    },
  ],
  postCSVTitle: "",
  dataColumn: [
    {
      key: "follow_call_status",
      name: "フォローコールステータス",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "170px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "list",
      detail: true,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "follow_call_do_date",
      name: "架電・フォローコール日時",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "170px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "date",
      detail: true,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "follow_call_date",
      name: "希望架電日",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "80px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "date",
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "follow_call_hope_time",
      name: "希望架電時間",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "100px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "follow_call_memo",
      name: "備考",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: null,
      detail: false,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "contract_number",
      name: "申込番号",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: true,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "apply_date",
      name: "申込日",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "70px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "date",
      detail: true,
      edit: false,
      editId: "id",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "opening_date",
      name: "開通日",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "70px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "date",
      detail: true,
      edit: false,
      editId: "id",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "post_date",
      name: "システム登録日",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "date",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "product_name",
      name: "商材名",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "product",
      detail: true,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "service_plan_name",
      name: "プラン名",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: true,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "contract_state",
      name: "ステータス",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: true,
      edit: false,
      editId: "id",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "customer_phone_number",
      name: "顧客-電話番号",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "100px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "kanzen",
      detail: false,
      edit: false,
      editId: "id",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "customer_name",
      name: "顧客-氏名",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "90px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "bubun",
      detail: false,
      edit: false,
      editId: "id",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "sale_company_name",
      name: "パートナー",
      tableDetailAuth: ["マスターアカウント", "スタッフアカウント"],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "company",
      detail: true,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "sale_account_name",
      name: "営業アカウント",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: false,
      serchType: "sale_account",
      detail: true,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "sale_account_name",
      name: "営業アカウント",
      tableDetailAuth: ["スタッフアカウント", "パートナー", "営業アカウント"],
      table: false,
      tableMinWidth: "150px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "sale_account",
      detail: false,
      edit: false,
      editType: null,
      editId: "",
      add: false,
      addType: null,
      addMessage: "",
    },
    {
      key: "follow_call_do_account_name",
      name: "フォローコールアカウント",
      tableDetailAuth: [
        "マスターアカウント",
        "スタッフアカウント",
        "パートナー",
        "営業アカウント",
      ],
      table: true,
      tableMinWidth: "180px",
      sort: false,
      tableValue: "text",
      serch: true,
      serchType: "sale_account",
      detail: true,
      edit: false,
      editId: "",
      editType: null,
      add: false,
      addType: null,
      addMessage: "",
    },
  ],
  subTable: [],
};
